import { Environment } from './environment.model';

export const environment: Environment = {
  baseUrl: 'https://api.flomoni.sk',
  eventUrl: 'https://notifier.flomoni.sk',
  host: 'https://flomoni.sk',
  authToken: 'ZmxvbW9uaTo3WDQwbUljU2Q2bzAxd0tl',
  backofficeUrl: 'https://backoffice.flomoni.sk',
  spominamUrl: 'https://spominam.sk/',
  spominamAuthToken: '',
  smarlookKey: 'bb156a2efadbc9414bf864699a5fbafba7dbaa6e',
  gtmId: 'GTM-THXFVTDG',
  ga: 'G-EJY1W9VDZX',
};
